module.exports = __webpack_public_path__ + "img/banner.3aabf719.jpeg";